export const isNonProductionEnvironment = () => {
	const env = process.env.REACT_APP_ENV
	return !env || env === 'development' || env === 'staging'
}

export const getAdminEnvironment = () => {
	const env = process.env.REACT_APP_ENV
	if (!env || env === 'development') return 'development'
	if (env === 'staging') return 'staging'
	return 'production'
}

export const applyEnvironmentFavicon = () => {
	const environment = getAdminEnvironment()
	if (environment === 'production') return

	const publicUrl = process.env.PUBLIC_URL || ''
	const href = `${publicUrl}/favicon-${environment}.png`
	const links = document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']")

	if (!links.length) {
		const link = document.createElement('link')
		link.rel = 'icon'
		link.type = 'image/png'
		link.href = href
		document.head.appendChild(link)
		return
	}

	links.forEach((link) => {
		link.type = 'image/png'
		link.href = href
	})
}
